
import axios from 'axios';
//import config from '../../config';
import {config} from '../../config'



export const postUploadUserProfileImage = (formData,userId)=>{
  //  //console.log("user profile image upload çalıştı");
         //   try{
            const url = `${config.apiUrl}/v1/upload/userProfileImage/${userId}`;
            return  axios.post(url,formData,{
                        headers:{
                            'Content-Type':'multipart/form-data'
                        }
                }).then(response => response.data);
}


